import React, {useEffect, useRef, useState} from "react";

const ExpandableHtmlText = ({ shouldExpand = false, showReadMore = true, onChange, content, maxHeight = 100, additionalContent, children }) => {
    const [isExpanded, setIsExpanded] = useState(shouldExpand);
    const [showButton, setShowButton] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        setIsExpanded(shouldExpand);
    }, [shouldExpand]);

    useEffect(() => {
        if (contentRef.current) {
            setShowButton(contentRef.current.scrollHeight > maxHeight);
        }
    }, [additionalContent, content, maxHeight]);

    return (
        <React.Fragment>
            <div className="rich-text-display">
                <div className="w-full max-w-2xl">
                    <div
                        ref={contentRef}
                        className={`relative overflow-hidden transition-all duration-300 ease-in-out${
                            isExpanded ? '' : ` max-h-${maxHeight / 4}`
                        }`}
                        style={{maxHeight: isExpanded ? `${contentRef.current?.scrollHeight}px` : `${maxHeight}px`}}
                    >
                        <div dangerouslySetInnerHTML={{__html: content}}/>

                        {additionalContent}
                        {!isExpanded && showButton && (
                            <div
                                className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent"/>
                        )}
                    </div>

                    {showReadMore && showButton && (
                        <button
                            onClick={async () => {
                                if (TB.isDefined(onChange)) {
                                    onChange(!isExpanded)
                                } else {
                                    setIsExpanded(!isExpanded);
                                }
                            }}
                            className="float-right mr-3 mt-2 text-blue-600 hover:text-blue-800 font-medium focus:outline-none"
                        >
                            {isExpanded ? 'Show Less' : 'Read More'}
                        </button>
                    )}
                </div>
            </div>
            {showButton && children}
        </React.Fragment>
    );
};

export default ExpandableHtmlText;